import { ColorTypes, actions } from "@omegagrid/core";
import { msg } from "@omegagrid/localize";
import rp, { CodeEditorAdapter, CodeEditorOptions, CodeEditor, ContentOptions } from "@reporting/rp-app-host";
import { File, MetadataTableColumn } from "@reporting/rp-types/etl";

export class FileMetadataEditorAdapter extends CodeEditorAdapter<CodeEditor> {

	get etlClient() { return rp.services.get('etl') }

	constructor(private file: File) { super() }

	getContent(opt: ContentOptions) : string {
		if (typeof this.file.metadata_definition == 'object') {
			return JSON.stringify(this.file.metadata_definition, null, 2);
		}
		return this.file.metadata_definition ?? '{}';
	}

	async save(content: string) {
		try {
			const def = JSON.parse(content);
			this.file.metadata_definition = def;
			await this.etlClient.post(`files`, this.file);
		} catch (e) {
			rp.host.bucket.showAlert({
				type: 'danger',
				content: msg('Invalid JSON content')
			});
			return false;
		}
	}

	async onAction(action: actions.Action) {
		if (action.key == 'extract') {
			try {
				const columns = await this.etlClient.get<MetadataTableColumn[]>(
					`files/${this.file.id_file}/metadata`
				);
				this.component.editor.content = JSON.stringify(columns, null, 2);
				this.component.edit();
				this.component.dispatchEvent(new CustomEvent('edit', { bubbles: true, composed: true }));
			} catch (e) {
				// request failures are already surfaced by the global service error handler
			}
		}
	}

	getOptions(): CodeEditorOptions {
		return this.createOptions({
			history: false,
			language: 'json',
			toolbar: {
				extract: {
					id: 'extract',
					type: 'button',
					text: msg('Extract from file'),
					color: ColorTypes.Blue,
					icon: 'columns-3',
					enabled: true,
					disabled: !this.file.exists,
					title: this.file.exists ? undefined : msg('File does not exist'),
					ord: 3
				},
			}
		});
	}

}
